/**
 * Zoom steps shared by the Gantt charts that expose +/- buttons. The steps are
 * coarse on purpose: below ~10% the hour labels collapse into each other and
 * above 400% a day no longer fits on screen.
 */
export const ZOOM_LEVELS = [
  10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 75, 100, 200, 400,
]

export const ZOOM_MIN = ZOOM_LEVELS[0]!
export const ZOOM_MAX = ZOOM_LEVELS[ZOOM_LEVELS.length - 1]!

export const prevZoom = (zoom: number): number => {
  for (let i = ZOOM_LEVELS.length - 1; i >= 0; i--) {
    if (ZOOM_LEVELS[i]! < zoom) return ZOOM_LEVELS[i]!
  }
  return ZOOM_MIN
}

export const nextZoom = (zoom: number): number => {
  for (const level of ZOOM_LEVELS) {
    if (level > zoom) return level
  }
  return ZOOM_MAX
}
